const legales = {
  advertenciaPagos: 'Bajo ningún motivo envíes dinero o realices pagos.',
  advertenciaPagosReclutador:
    'Ningún reclutador te pedirá pagar por rendir un test, prueba, capacitación, recibir un antecedente u otro motivo.',
}

export default legales
